import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as PaymentsActions } from 'store/ducks/payments';

import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Points/Payments/components';

class Edit extends Component {
  state = {
    data: {
      external_id: '',
      name: '',
      type_payment: '',
      description: '',
      score: true,
    },

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Métodos de Pagamento', to: '/points/payments' },
      { name: 'Detalhes', to: '' },
    ],
  };

  componentDidMount() {
    this.props.getPaymentRequest(this.handleGetId());
  }

  componentDidUpdate(oldProps) {
    const { payment } = this.props;

    if (oldProps.payment.loading && !payment.loading) {
      this.setState({
        data: {
          external_id: payment.data.attributes.external_id,
          name: payment.data.attributes.name,
          type_payment: payment.data.attributes.type_payment,
          description: payment.data.attributes.description,
          score: payment.data.attributes.score,
        },
      });
    }
  }

  handleGetId = () => {
    const match = matchPath(this.props.location.pathname, { path: '/points/payments/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.state;

    this.props.updatePaymentRequest(this.handleGetId(), {
      payment_method: {
        ...form,
        type_payment: form.type_payment === "" ? null : form.type_payment,
      },
    });
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form data={data} saving={update.loading} onChange={this.handleChange} onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

const mapState = state => ({
  payment: state.payments.detail,
  update: state.payments.update,
});

const mapActions = dispatch => bindActionCreators(PaymentsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
